// extracted by mini-css-extract-plugin
export var headerCell = "_5x-1";
export var loadingStateCell = "_5x-4";
export var rowWrapper = "_5x-3";
export var standaloneTable = "_5x-5";
export var table = "_5x-0";
export var white = "_5x-2";